import { AddToListButton } from './addToListButton'

export default AddToListButton
